const UndoIcon = ({ size = 20, fill = 'white' }) => (
  <svg
    fill={fill}
    height={size}
    width={size}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <g>
          <path
            d="M512,255.999C512,133.046,412.344,33.39,289.391,33.39c-119.929,0-217.675,94.819-222.411,213.585l-28.978-28.978
				c-8.693-8.693-22.788-8.693-31.482,0c-8.693,8.693-8.693,22.788,0,31.482l66.783,66.783c8.693,8.693,22.788,8.693,31.482,0
				l66.783-66.783c8.693-8.693,8.693-22.788,0-31.482c-8.693-8.693-22.788-8.693-31.482,0l-28.53,28.53
				c4.923-93.959,82.649-168.615,177.836-168.615c98.364,0,178.087,79.723,178.087,178.087c0,0.469,0.019,0.933,0.048,1.394
				c-0.037,0.476-0.084,0.949-0.092,1.435c-0.2,13.245-1.87,26.424-4.964,39.201c-2.872,11.954,4.497,23.975,16.451,26.847
				c1.759,0.423,3.495,0.623,5.231,0.623c10.04,0,19.144-6.856,21.615-17.052c3.851-15.939,5.921-32.39,6.189-48.929
				c0.009-0.553-0.009-1.099-0.04-1.643C511.967,257.256,512,256.632,512,255.999z"
          />
          <path
            d="M458.908,365.035c-9.55-7.769-23.552-6.278-31.299,3.272c-8.281,10.195-17.742,19.523-28.138,27.693
				c-9.661,7.591-11.309,21.593-3.74,31.254c4.408,5.588,10.93,8.504,17.519,8.504c4.808,0,9.683-1.558,13.757-4.764
				c12.978-10.218,24.821-21.882,35.172-34.638C469.927,386.806,468.458,372.782,458.908,365.035z"
          />
          <path
            d="M328.659,429.747c-12.8,2.872-26.001,4.341-39.268,4.341c-12.31,0-22.261,9.973-22.261,22.261
				c0,12.288,9.951,22.261,22.261,22.261c16.54,0,33.035-1.825,49.041-5.432c11.999-2.694,19.523-14.603,16.829-26.602
				S340.591,427.098,328.659,429.747z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default UndoIcon;
